<template>
  <div>
    <CRow>
      <CCol col>
        <CCard>
          <CCardHeader>
            <strong> Modulo Tipo de Habitación - Listar</strong>
          </CCardHeader>
          <CCardBody>
            <b-row>
              <b-col sm="12" md="8"></b-col>
              <b-col sm="6" md="2">
                <b-link
                  v-if="Permission('TypeRoomAdd')"
                  class="btn form-control btn-primary"
                  :to="{ path: '/tipo-habitacion/nuevo' }"
                  append
                  >NUEVO</b-link
                >
              </b-col>
              <b-col sm="6" md="2">
                <b-input-group>
                  <b-form-input
                    v-model="search"
                    class="form-control"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button variant="primary" @click="ListTypeRoom">
                      <b-icon icon="search"></b-icon
                    ></b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>

            <div class="table-responsive mt-3">
              <table class="table table-hover table-bordered">
                <thead>
                  <tr>
                    <th width="5%" class="text-center">#</th>
                    <th width="55%" class="text-center">Nombre</th>
                    <th width="10%%" class="text-center">Imagen</th>
                    
                    <th width="10%" class="text-center">Estado</th>
                    <th width="10%" class="text-center">Acciones</th>
                  </tr>
                </thead>
                <tbody v-for="(item, it) in data_table" :key="item.id_type_room">
                  <tr>
                    <td class="align-middle text-center ">{{ it + 1 }}</td>
                    <td class="align-middle text-left"> {{ item.name }}</td>
                    <td class="align-middle text-center"> 
                        <img class="img-fluid" :src="url_base + item.photo" alt="">
                    </td>
                    <td class="align-middle text-center">
                      {{ item.state == 1 ? "Activo" : "Inactivo" }}
                    </td>
                    <td class="align-middle text-center">
                      <b-dropdown bloque size="sm" text="Acciones" right>
                        <b-dropdown-item
                          v-if="Permission('TypeRoomEdit')"
                          @click="EditTypeRoom(item.id_type_room)"
                          >Editar</b-dropdown-item
                        >
                        <b-dropdown-item
                          v-if="Permission('TypeRoomView')"
                          @click="ViewTypeRoom(item.id_type_room)"
                          >Ver</b-dropdown-item
                        >
                        <b-dropdown-item
                          v-if="Permission('TypeRoomDelete')"
                          @click="ConfirmDeleteTypeRoom(item.id_type_room)"
                          >Eliminar</b-dropdown-item
                        >
                      </b-dropdown>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <b-row class="mt-4">
              <b-col md="8">
                <b-pagination
                  v-model="currentPage"
                  v-on:input="ListTypeRoom"
                  :total-rows="rows"
                  :per-page="perPage"
                  align="center"
                ></b-pagination>
              </b-col>
              <b-col md="4 text-center">
                <p>Pagina Actual: {{ currentPage }}</p>
              </b-col>
            </b-row>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
const axios = require("axios").default;
const Swal = require("sweetalert2");
const je = require("json-encrypt");
import { mapState } from "vuex";

export default {
  name: "UsuarioList",
  data() {
    return {
      module:'TypeRoom',
      perPage: 15,
      currentPage: 1,
      rows: 0,
      search: "",
      data_table: [],
    };
  },
  mounted() {
    this.ListTypeRoom();
  },
  methods: {
    ListTypeRoom,
    EditTypeRoom,
    ViewTypeRoom,
    ConfirmDeleteTypeRoom,
    DeleteTypeRoom,
    Permission,
  },

  computed: {
    ...mapState(["url_base"]),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    },
  },
};

//listar usuario
function ListTypeRoom() {
  let search = this.search == "" ? "all" : this.search;
  let me = this;
  let url =
    this.url_base + "type-room/list/" + search + "?page=" + this.currentPage;

  axios({
    method: "GET",
    url: url,
    headers: {
      token: this.token,
      module: this.module,
      role: 1,
    },
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.rows = response.data.result.total;
        me.data_table = response.data.result.data;
      } else {
        Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      }
    })
    .catch((error) => {
    });
}

// Editar usuario
function EditTypeRoom(id_type_room) {
  this.$router.push({
    name: "TypeRoomEdit",
    params: { id_type_room: je.encrypt(id_type_room) },
  });
}

// Ver Usuario
function ViewTypeRoom(id_type_room) {
  this.$router.push({
    name: "TypeRoomView",
    params: { id_type_room: je.encrypt(id_type_room) },
  });
}

// Confirmar eliminar
function ConfirmDeleteTypeRoom(id_type_room) {
  Swal.fire({
    title: "Esta seguro de eliminar el registro?",
    text: "No podrás revertir esto!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si, Estoy de acuerdo!",
  }).then((result) => {
    if (result.value) {
      this.DeleteTypeRoom(id_type_room);
    }
  });
}

// eliminar usuario
function DeleteTypeRoom(id_type_room) {
  let me = this;
  let url = this.url_base + "type-room/delete/" + id_type_room;
  axios({
    method: "delete",
    url: url,
    headers: {
      token: this.token,
      module: this.module,
      role: 4,
    },
  })
    .then(function (response) {
      if (response.data.status == 200) {
        //eliminado del objeto
        for (var i = 0; i < me.data_table.length; i++) {
          if (me.data_table[i].id_type_room == id_type_room) {
            me.data_table.splice(i, 1);
            break;
          }
        }
        Swal.fire("Sistema", "El registro ha sido eliminado", "success");
      } else {
        Swal.fire("Sistema","El registro no ha sido eliminado","error");
      }
    })
    .catch((error) => {

    });
}

// permisos
function Permission(module_permission) {
  let user_permissions = window.localStorage.getItem("user_permissions");
  user_permissions = JSON.parse(JSON.parse(je.decrypt(user_permissions)));
  if (user_permissions.indexOf(module_permission) > -1) {
    return true;
  } else {
    return false;
  }
}
</script>
